import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, useRef } from 'react';
import { CourierJson } from 'types/bundleTypes';

interface CourierSelectionProps {
  list: CourierJson[];
  selected: CourierJson;
  onSelected: (_: ChangeEvent<any>, value: string | CourierJson) => void;
}

export const CourierSelection = ({
  onSelected,
  ...props
}: CourierSelectionProps) => {
  /* This `useRef` for defaultValue is used to handle the MUI error */
  /* `Material-UI: A component is changing the default value state of an uncontrolled Autocomplete after being initialized. To suppress this warning opt to use a controlled Autocomplete.` */
  const defaultValue = useRef(props.selected);

  return (
    <Autocomplete
      id="preferred-areas-courier"
      options={props.list}
      getOptionLabel={option => `${option.fullName} (${option.id})`}
      renderOption={(props, option) => (
        <div>
          {props.fullName} ({props.id})
        </div>
      )}
      renderInput={params => (
        <TextField
          autoFocus
          {...params}
          variant="outlined"
          placeholder="Type and select courier's name"
        />
      )}
      defaultValue={defaultValue.current}
      onChange={onSelected}
    />
  );
};
